import { Link } from '../common';
import { Opportunity } from './opportunity';
import { OpportunityDocumentType } from './opportunity-document-type';

export interface OpportunityDocument {
  opportunityDocumentId: number;
  sequenceId: number;
  opportunity: Opportunity;
  opportunityDocumentType: OpportunityDocumentType;
  fileName: string;
  documentUploadDate: string;
  links: Link;
}
